import React from 'react'
import { makeStyles } from '@mui/styles'
import classNames from 'classnames'
import CarouselArrow from './carousel-arrow'
import ArrowRightSvg from 'assets/images/icons/arrow_right.svg'

export const CarouselRightArrow = (props) => {
  const { onClick, className, customClass, smallArrow, fillColor } = props
  const classes = useStyles(props)
  const arrowClasses = classNames(className, classes.rightArrow, customClass)
  return (
    <CarouselArrow
      icon={ArrowRightSvg}
      onClick={onClick}
      className={arrowClasses}
      smallArrow={smallArrow}
      fillColor={fillColor}
    />
  )
}

const useStyles = makeStyles(() => ({
  rightArrow: {
    right: '20px',
  },
}))

export default CarouselRightArrow
